module.exports = __webpack_public_path__ + "static/IMG_4222-f1067c020753d831dcf13717a724c36b.jpeg";